/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import StyledText from "ae-base/Base/StyledText";
import { Platform } from "react-native";

import { useResources } from "@aetonix/hooks";

export default function OutputValue(props) {
	const { localizeFrom, localize } = useResources();
	const schema = props.schema;
	const data = props.data;

	let style = props.style;
	if (Platform.OS !== "android" && Platform.OS !== "ios")
		style = [style, {textAlign: "justify", wordWrap: "break-word"}];

	const valueLocalization = schema.valueLocalization || schema.value_localization;
	let text = valueLocalization ? localizeFrom(valueLocalization, data) || localize(valueLocalization + "." + data) || data : data;
	if(typeof text === "object") text = "";

	return (
		<StyledText selectable={true} style={style} contrast={props.contrast} black={!props.contrast}>{text}</StyledText>
	);
}